import { render, staticRenderFns } from "./ReportTeacher.vue?vue&type=template&id=5e6ae504&"
import script from "./ReportTeacher.vue?vue&type=script&lang=js&"
export * from "./ReportTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports